import Image from "next/image";
import { mockupSrc } from "@/lib/images/references";

/**
 * Mockup-Bild aus `public/images/mockups/` (Auftrag 2026-10-28, Abschnitt
 * 1.5 b). Dateien werden mit Claude Design erzeugt und über
 * `npm run images:manifest` registriert. Fehlt die Datei, wird der Slot
 * weggelassen – kein Platzhalter.
 */
export function MockupImage({
  name,
  alt,
  caption,
  sizes = "(min-width: 1024px) 560px, 100vw",
  priority = false,
  aspect = "16/10",
  className = "",
}: {
  /** Dateiname inkl. Endung, z. B. „ki-analyse-massnahmenplan.webp“. */
  name: string;
  /** Beschreibt, was das Dokument bzw. die Oberfläche zeigt. */
  alt: string;
  caption?: string;
  sizes?: string;
  priority?: boolean;
  /** Seitenverhältnis des Rahmens, z. B. „16/10“ oder „4/3“. */
  aspect?: string;
  className?: string;
}) {
  const src = mockupSrc(name);
  if (!src) return null;
  return (
    <figure className={className}>
      <div
        className="relative overflow-hidden rounded-2xl border"
        style={{ borderColor: "var(--border)", backgroundColor: "var(--bg-secondary)", aspectRatio: aspect, boxShadow: "var(--card-shadow)" }}
      >
        <Image src={src} alt={alt} fill priority={priority} sizes={sizes} className="object-cover object-top" />
      </div>
      {caption && (
        <figcaption className="mt-3 text-sm" style={{ color: "var(--text-tertiary)" }}>
          {caption}
        </figcaption>
      )}
    </figure>
  );
}
